export enum ReportSaveMode {
  CreditUnion = 1,
  Configuration = 2,
}

export type ListItemType = {
  id: number;
  hasBeenSubmitted: boolean;
  name: string;
  saveMode: ReportSaveMode;
  creditUnionsCount: number;
  timestamp: string;
};

export type List = {
  total: number;
  items: ListItemType[];
};
